const TimeLeft = ({ endtime }) => {
  if (!endtime) return;
  const total = Date.parse(endtime) - Date.parse(new Date());
  //const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  if (total < 0) return <span className="status--done">--הסתיים--</span>
  return (
    <>
      {days > 0 &&<span>{days} ימים </span> }
      {hours > 0 && <span>{hours} שעות </span> }
      <span>{minutes} דקות </span>
    </>
  );
};

export default TimeLeft;
